var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.parceiroConfig)?_c('div',[_c('land-page-slider',{attrs:{"parceiro":_vm.parceiro}}),(
                _vm.parceiroConfig.sessoes.about &&
                _vm.parceiroConfig.sessoes.about.campos
            )?_c('section',{ref:'about',staticClass:"section"},[_c('land-page-about')],1):_vm._e(),(
                _vm.parceiroConfig.sessoes.tutorial &&
                _vm.parceiroConfig.sessoes.tutorial.campos
            )?_c('section',{ref:'tutorial',staticClass:"section"},[_c('land-page-tutorial')],1):_vm._e(),(
                _vm.parceiroConfig.sessoes.partners &&
                _vm.parceiroConfig.sessoes.partners.arquivos.length > 0 &&
                !_vm.portalCamec
            )?_c('section',{staticClass:"section"},[_c('land-page-partner')],1):_vm._e(),(
                _vm.parceiroConfig.sessoes.contact &&
                _vm.parceiroConfig.sessoes.contact.campos
            )?_c('section',{ref:'contact'},[_c('land-page-contact')],1):_vm._e(),_c('land-page-footer')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }